var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comment)?_c('div',{staticClass:"created-comment"},[_c('div',{staticClass:"comment-label"},[_vm._v(_vm._s(_vm.$t('timeSheet.labels.comment')))]),_c('div',{staticClass:"comment-value"},[_vm._v(_vm._s(_vm.comment))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }